// #region imports

// --- Angular
import { Injectable } from '@angular/core';

// --- RxJs
import { of } from 'rxjs';
import { delay } from 'rxjs/operators';

// --- HS Code
import { SurveyResponseModel } from '../../../models';
import { AppService } from '../app.service';
import { InvitationBaseService } from './invitation-base.service';
import { ResponseBaseService } from './response-base.service';

// #endregion

@Injectable({
  providedIn: 'root',
})
export class InvitationMockService extends InvitationBaseService {
  constructor(
    private appService: AppService,
    private responseService: ResponseBaseService
  ) {
    super();
  }

  sendInvitations(surveyResponseModel: SurveyResponseModel): void {
    if (!surveyResponseModel) {
      return;
    }

    const delayMilliseconds = Math.random() * 1000 + 300;

    this.appService.setLoading(true);

    of({ sent: true })
      .pipe(delay(delayMilliseconds))
      .subscribe((dummyResult) => {
        this.appService.setLoading(false);
        this.responseService.updateStatus(surveyResponseModel);
      });
  }
}
